import LegalLayout from '@/pages/legal/components/LegalLayout';

export default function MentionsLegales() {
  return (
    <LegalLayout
      eyebrow="Informations légales"
      title="Mentions légales"
      updatedAt="Septembre 2026"
      intro="Conformément à la législation en vigueur au Royaume du Maroc, notamment la loi 09-08 relative à la protection des données personnelles, voici les informations relatives à l'éditeur et à l'exploitation du site MEDICACLIC."
    >
      <h2>1. Éditeur du site</h2>
      <p>
        Le site <strong>medicaclic.com</strong> est édité et exploité par <strong>MEDICACLIC</strong>,
        représentée par <strong>Mme Lamia Doghmi</strong>, agissant en qualité d'éditrice de la plateforme.
      </p>
      <ul>
        <li>Dénomination : MEDICACLIC</li>
        <li>Responsable de la publication : Mme Lamia Doghmi</li>
        <li>ICE : 003548663000080</li>
        <li>Siège : Rabat, Maroc</li>
        <li>Contact : contact@medicaclic.com</li>
        <li>Support : WhatsApp (canal prioritaire)</li>
      </ul>

      <h2>2. Hébergement</h2>
      <p>
        Le site est hébergé et publié via l'infrastructure de <strong>Readdy AI</strong>.
        L'ensemble des contenus et données applicatives sont hébergés sur des serveurs conformes
        aux standards de sécurité en vigueur. Pour toute question relative à l'hébergement,
        contactez-nous à l'adresse indiquée ci-dessus.
      </p>

      <h2>3. Nature du service</h2>
      <p>
        MEDICACLIC est une plateforme de mise en relation entre patients et professionnels de santé
        (médecins spécialistes, laboratoires d'analyses, centres de radiologie, pharmacies,
        paramédicaux) sur le territoire de Rabat. MEDICACLIC n'exerce aucune activité médicale :
        elle ne fournit ni consultation, ni diagnostic, ni prescription. La relation de soins
        s'établit directement et exclusivement entre le patient et le praticien.
      </p>

      <h2>4. Propriété intellectuelle</h2>
      <p>
        L'ensemble des éléments du site (structure, textes, interface, marques, logos, base de données,
        éléments graphiques) est la propriété exclusive de MEDICACLIC ou de ses partenaires, et est
        protégé par les lois marocaines et internationales relatives à la propriété intellectuelle.
        Toute reproduction, représentation, modification ou exploitation, totale ou partielle,
        sans autorisation écrite préalable est interdite.
      </p>

      <h2>5. Liens hypertextes</h2>
      <p>
        Le site peut contenir des liens vers des sites tiers (agendas partenaires, services de
        paiement, réseaux sociaux). MEDICACLIC n'exerce aucun contrôle sur leur contenu et décline
        toute responsabilité quant à leur disponibilité ou à leurs pratiques.
      </p>

      <h2>6. Responsabilité</h2>
      <p>
        MEDICACLIC s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées
        (fiches praticiens, coordonnées, disponibilités). Les informations de disponibilité étant
        issues d'agendas tiers en temps réel, des écarts ponctuels peuvent survenir. MEDICACLIC
        ne saurait être tenue responsable des dommages directs ou indirects résultant de
        l'utilisation du site.
      </p>

      <h2>7. Droit applicable</h2>
      <p>
        Les présentes mentions légales sont soumises au droit marocain. Tout litige relatif à
        l'utilisation du site relève de la compétence exclusive des tribunaux de Rabat.
      </p>
    </LegalLayout>
  );
}